module.exports = {
      id: "nagorik-usage",
      viewBox: "0 0 336 47",
      url: "/" + "svg-sprite-21c17c4d458cf2e2be6dd4c01f9ab03b.svg#nagorik",
      toString: function () {
        return this.url;
      }
    }